import Pagination from "@/components/Pagination/Pagination"
import styles from "./BottomToolbar.module.css"
import { useStyleFamilyCatalog } from "@/contexts/StyleFamilyCatalogContext"
import { styleFamilyCatalogMaxRawTotal } from "@/config"

export default function BottomToolbar() {
  const catalog = useStyleFamilyCatalog()
  const catalogPriming =
    catalog != null &&
    catalog.rawTotal > 0 &&
    catalog.rawTotal <= styleFamilyCatalogMaxRawTotal &&
    (catalog.status === "idle" || catalog.status === "loading")

  if (catalogPriming) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Pagination />
      </div>
    </div>
  )
}
